/**
 * Einstiegspunkt der Portfolio Wizard Anwendung
 * Initialisiert React und rendert die Hauptkomponente
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Cloudscape Design System Styles
import '@cloudscape-design/global-styles/index.css';

// Removed Amplify Authentication - using API Key authentication instead

/**
 * Rendert die Anwendung in das DOM
 */
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);